import React, { useEffect, useState } from 'react';
import { Grid, InputLabel, FormControl, Input, Snackbar } from "@material-ui/core";
import MuiAlert from '@material-ui/lab/Alert';
import { useParams, useLocation, useHistory } from 'react-router-dom'
import { useSelector, shallowEqual } from 'react-redux'
import { GetCoachServiceByID, UpdateCoachService } from '../api'
import {RxCross2} from 'react-icons/rx'

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const EditServices = ({setOpenEditService, fetchServicesList, selectedService}) => {
    const { user } = useSelector(({ auth }) => auth, shallowEqual);
    // const [list, setList] = useState([{ name: 'linkedIn', date: '09-12-2022' },{ name: 'linkedIn', date: '09-12-2022' },{ name: 'linkedIn', date: '09-12-2022' },{ name: 'linkedIn', date: '09-12-2022' },{ name: 'linkedIn', date: '09-12-2022' },{ name: 'linkedIn', date: '09-12-2022' },{ name: 'linkedIn', date: '09-12-2022' },{ name: 'linkedIn', date: '09-12-2022' },])
    const location = useLocation();
    const params = useParams();
    const history = useHistory();

    const [pending, setPending] = useState(false);

    const [form, setForm] = useState(()=>({
        pending: false,
        category: '',
        title: '',
        subtitle: '',
        price: '',
        time: '',
        discription: '',
        userId: user.id,
    }))

    const [date, setDate] = useState({
        days: '',
        hours: '',
        mintues: ''
    })

    useEffect(()=>{
        setForm((pre)=>({
            ...pre,
            ...selectedService
        }))
        if(selectedService.time){
            let time = selectedService.time.split(',');
            time.forEach(ele => {
                if(ele.includes('days')){
                    setDate((pre)=>({
                        ...pre,
                        days: ele.match(/\d+/g).length > 0 ? ele.match(/\d+/g)[0] : 0
                    }))
                }else if(ele.includes('hours')){
                    setDate((pre)=>({
                        ...pre,
                        hours: ele.match(/\d+/g).length > 0 ? ele.match(/\d+/g)[0] : 0
                    }))
                }else if(ele.includes('mintues')){
                    setDate((pre)=>({
                        ...pre,
                        mintues: ele.match(/\d+/g).length > 0 ? ele.match(/\d+/g)[0] : 0
                    }))
                }
            });
        }
    }, [])

    useEffect(()=>{
        const { days, hours, mintues } = date
        if(days == 0 && hours == 0 && mintues == 0){
            setForm((pre)=>({
                ...pre,
                time: ''
            }))
            return ;
        }

        let time = '';
        if(days){
            time = `${days} days`
        }
        if(hours){
            time += `, ${hours} hours`
        }
        if(mintues){
            time += `, ${mintues} mintues`
        }
        setForm((pre)=>({
            ...pre,
            time: time
        }))
    }, [date])

    const [snackbar, setSnackbar] = useState(()=>({
        isOpen: false,
        message: '',
        type: 'success'
    }))

    useEffect(()=>{
        console.log(params, 'params');
        console.log(location, 'location');
    }, [params, location])

    useEffect(()=>{
        (async function(){
            if(location.state == undefined){
                setPending(true);
                try{
                    let res = await GetCoachServiceByID(params.id)
                    setForm((pre)=>({
                        ...pre,
                        ...res.data
                    }))
                    console.log(res);
                }catch(ex){
                    console.log(ex);
                    history.push('/services')
                }finally{
                    setPending(false);
                }
            }else{
                setForm((pre)=>({
                    ...pre,
                    ...location.state.service
                }))
            }
        })();
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();

        const { title, category, discription, price, subtitle, time } = form;

        if(title == '' || category == '' || discription == '' || price == '' || subtitle == "" || time == ""){
            setSnackbar((pre)=>({
                ...pre,
                isOpen: true,
                message: 'Please fill all fields.',
                type: 'error'
            }))
            return ;
        }

        try{
            setForm((pre)=>({...pre, pending: true}))
            await UpdateCoachService(form);
            fetchServicesList();
            setOpenEditService(false);
            // history.push('/services');

        }catch(ex){
            console.log(ex);
        }finally{
            setForm((pre)=>({...pre, pending: false}))
        }
    }

    const handleChange = (e) => {
        e.persist();
        // console.log(e);
        setForm((pre)=>({
            ...pre,
            [e.target.name]: e.target.value
        }))
    }



    return <>
        <Snackbar open={snackbar.isOpen} autoHideDuration={6000} onClose={()=>{setSnackbar((pre)=>({...pre, isOpen: false}))}}>
            <Alert onClose={()=>{setSnackbar((pre)=>({...pre, isOpen: false}))}} severity={snackbar.type}>
                { snackbar.message }
            </Alert>
        </Snackbar>
        {/* {pending ? 
        <div className="w-100 d-flex align-items-center justify-content-between mb-2" >
            <div class="spinner-border text-danger mx-auto" role="status"></div>
        </div>: 
        <form onSubmit={handleSubmit} className='add-service-form'>
            <div className="container mt-5 ml-0 p-0" style={{ maxWidth: '750px' }}>
                <div className="row">
                    <div className="col-md-12">
                    <div className='serviceTitle'>
                        <h1>Edit Service</h1>
                        { !form.isEditeable  ? 
                            <button type='button' onClick={(e)=>{e.preventDefault(); setForm((pre)=>({...pre, isEditeable: true}))}}>Edit Service</button>
                            :
                            <button type="submit" disabled={form.pending} onSubmit={handleSubmit}>{ form.pending ? <div class="spinner-border text-white mx-auto" role="status"></div> : 'Save Service' }</button>
                        }
                    </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 mt-5">
                        <select name="category" value={form.category} disabled={!form.isEditeable} id="" className='form-control' onChange={handleChange}>
                            <option disabled selected>Category</option>
                            <option value="Resume">Resume</option>
                            <option value="Cover Letter">Cover Letter</option>
                            <option value="LinkedIn">LinkedIn</option>
                            <option value="Networking">Networking</option>
                            <option value="Job Search">Job Search</option>
                            <option value="Interview">Interview</option>
                            <option value="Negotiation">Negotiation</option>
                        </select>
                    </div>
                    <div className="col-md-6 mt-5">
                        <input className='form-control' disabled={!form.isEditeable} name='title' value={form.title} onChange={handleChange} type="text" placeholder='Title' />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 mt-5">
                        <input className='form-control' disabled={!form.isEditeable} value={form.subtitle} onChange={handleChange} name='subtitle' type="text" placeholder='Subtitle' />
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6 mt-5">
                                <div className="input-group mb-3">
                                <input className='form-control' disabled={!form.isEditeable} value={form.price} onChange={handleChange} name="price" type="number" placeholder='Price' />
                                    <div className="input-group-append">
                                        <span className="input-group-text" id="basic-addon2">$</span>
                                    </div>
                                </div>   
                            </div>
                            <div className="col-md-6 mt-5">
                                <input className='form-control' disabled={!form.isEditeable} value={form.time} onChange={handleChange} name="time" type="text" placeholder='Time' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 mt-5">
                        <textarea value={form.discription} disabled={!form.isEditeable} onChange={handleChange} name="discription" id="" placeholder='Description' className='form-control' cols="30" rows="10"></textarea>
                    </div>
                </div>
                
            </div>
        </form>
        } */}

<div className='  bg-white rounded-lg overflow-hidden pb-5 mt-5 main1'>
            <div className='Abg-c d-flex justify-content-between align-items-start px-5 '>
            <div className='  pt-5'>
            <h1 className='font3'>Edit Service</h1>
            <p>Share what are your offer, will share on your profile.</p>
            </div>
            <button disabled={form.pending} onClick={()=>{setOpenEditService(false)}} className='bg-transparent border-0 btnSize  pt-2'><RxCross2/></button>
            </div>

            <div className="container mt-5  px-5" >

                   <form onSubmit={handleSubmit}>
                <div className="row">
                <div className="col-12 mt-5">
                    <label htmlFor="" className='font-weight-bold'>Category</label>
                    <select className='form-control' name='category' value={form.category} onChange={handleChange} placeholder='Category'>
                            <option value="" disabled selected>Category</option>
                            <option value="Resume">Resume</option>
                            <option value="Cover Letter">Cover Letter</option>
                            <option value="LinkedIn">LinkedIn</option>
                            <option value="Networking">Networking</option>
                            <option value="Job Search">Job Search</option>
                            <option value="Interview">Interview</option>
                            <option value="Negotiation">Negotiation</option>

                            </select>
                </div>
                   
                </div>

                
                <div className="row">
                <div className="col-12 mt-5">
                    
                    <label htmlFor="" className='font-weight-bold'>Title</label>
                        {/* <div className='form-control' name='title' value={form.title} onChange={handleChange} type="text" placeholder='Product Designer|'>Product Designer|</div> */}
                        <input className='form-control' name='title' value={form.title} onChange={handleChange} type="text" placeholder='Title'/>
                    
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 mt-5">
                    <label htmlFor="" className='font-weight-bold'>Sub Title</label>
                        <input className='form-control' value={form.subtitle} onChange={handleChange} name='subtitle' type="text" placeholder='Subtitle' />
                    </div>
                    <div className="col-md-6 mt-5">
                    <label htmlFor="" className='font-weight-bold'>Price $</label>
                            <div className="input-group">
                                <input className='form-control' min={0} value={form.price} onChange={handleChange} name='price' type="number" placeholder='Price' />
                                <div class="input-group-append">
                                    <span class="input-group-text">$</span>
                                </div>
                            </div>
                    </div>
                </div>

                {/* <div className="row">
                    <div className="col-6 mt-5">
                            <label htmlFor="" className='font-weight-bold'>Date / Time</label>
                            <input className='form-control' value={form.time} onChange={handleChange} name='time' type="datetime-local" placeholder='Time' />
                    </div>
                
                </div> */}
                <div className="row">
                        <div className="col-4 mt-5">
                            <label htmlFor="" className='font-weight-bold'>Days</label>
                            <input className='form-control'  value={date.days} onChange={(e)=>{ e.persist(); setDate((pre)=>({...pre, days: e.target.value}))}} name='time' type="number" min={0} placeholder='Days' />
                        </div>
                        <div className="col-4 mt-5">
                            <label htmlFor="" className='font-weight-bold'>Hours</label>
                            <input className='form-control' value={date.hours} onChange={(e)=>{ e.persist(); setDate((pre)=>({...pre, hours: e.target.value}))}} name='time' type="number" min={0} max={60} placeholder='Hours' />
                        </div>
                        <div className="col-4 mt-5">
                            <label htmlFor="" className='font-weight-bold'>Mintues</label>
                            <input className='form-control' value={date.mintues} onChange={(e)=>{ e.persist(); setDate((pre)=>({...pre, mintues: e.target.value}))}} name='time' type="number" min={0} max={60} placeholder='Mintues' />
                        </div>

                    </div>

                
                <div className="row">
                    <div className="col-12 mt-5">
                    <label htmlFor="" className='font-weight-bold'>Description</label>
                        <textarea value={form.discription} onChange={handleChange} name="discription" id="" placeholder='Description' className='form-control'  rows="7"></textarea>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 mt-5 d-flex justify-content-center">
                        {/* <button type='submit' className='form_btn bg-transparent' disabled={form.pending}> */}
                        {/* Save as draft */}
                            {/* { form.pending ? <div class="spinner-border text-white mx-auto" role="status"></div> : 'Submit' } */}
                        {/* </button> */}
                        <button disabled={form.pending} className='form_btn form_btn1'>{ form.pending ? <div style={{color: '#3783E7'}} class="spinner-border mx-auto" role="status"></div> : 'Submit' }</button>
                    </div>
                </div>
            </form> 
            
        </div>
         
        </div>
    </>
}

export default EditServices;